export default "/_next/static/abb2d4dff78e2a813dbbad84d9ba37fa.svg";